import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { Heading } from "components/Heading";
import Engagement from "../tabs/Engagement";
import useMcapFilters from "../useMcapFilters";
import typography from "../typography";

export default function EngagementScreen() {
  const { filters, renderFilterBar } = useMcapFilters();

  return (
    <div className="page-content">
      <Helmet>
        <title>{typography.TAB_ENGAGEMENT} · MCAP</title>
      </Helmet>
      <Container fluid className="mcap-hub">
        <Heading heading={typography.TAB_ENGAGEMENT} />
        <Engagement filters={filters} filterBar={renderFilterBar("engagement")} />
      </Container>
    </div>
  );
}
